"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simpleLineIcons = void 0;
exports.simpleLineIcons = [
    'action-redo',
    'action-undo',
    'anchor',
    'arrow-down',
    'arrow-down-circle',
    'arrow-left',
    'arrow-left-circle',
    'arrow-right',
    'arrow-right-circle',
    'arrow-up',
    'arrow-up-circle',
    'badge',
    'bag',
    'ban',
    'basket',
    'basket-loaded',
    'bell',
    'book-open',
    'briefcase',
    'bubble',
    'bubbles',
    'bulb',
    'calculator',
    'calendar',
    'call-end',
    'call-in',
    'call-out',
    'camera',
    'camrecorder',
    'chart',
    'check',
    'chemistry',
    'clock',
    'close',
    'cloud-download',
    'cloud-upload',
    'compass',
    'control-end',
    'control-forward',
    'control-pause',
    'control-play',
    'control-rewind',
    'control-start',
    'credit-card',
    'crop',
    'cup',
    'cursor',
    'cursor-move',
    'diamond',
    'direction',
    'directions',
    'disc',
    'dislike',
    'doc',
    'docs',
    'drawer',
    'drop',
    'earphones',
    'earphones-alt',
    'emotsmile',
    'energy',
    'envelope',
    'envelope-letter',
    'envelope-open',
    'equalizer',
    'event',
    'exclamation',
    'eye',
    'eyeglass',
    'feed',
    'film',
    'fire',
    'flag',
    'folder',
    'folder-alt',
    'frame',
    'game-controller',
    'ghost',
    'globe',
    'globe-alt',
    'graduation',
    'graph',
    'grid',
    'handbag',
    'heart',
    'home',
    'hourglass',
    'info',
    'key',
    'layers',
    'like',
    'link',
    'list',
    'location-pin',
    'lock',
    'lock-open',
    'login',
    'logout',
    'loop',
    'magic-wand',
    'magnet',
    'magnifier',
    'magnifier-add',
    'magnifier-remove',
    'map',
    'menu',
    'microphone',
    'minus',
    'mouse',
    'music-tone',
    'music-tone-alt',
    'mustache',
    'note',
    'notebook',
    'options',
    'options-vertical',
    'organization',
    'paper-clip',
    'paper-plane',
    'paypal',
    'pencil',
    'people',
    'phone',
    'picture',
    'pie-chart',
    'pin',
    'plane',
    'playlist',
    'plus',
    'power',
    'present',
    'printer',
    'puzzle',
    'question',
    'refresh',
    'reload',
    'rocket',
    'screen-desktop',
    'screen-smartphone',
    'screen-tablet',
    'settings',
    'share',
    'share-alt',
    'shield',
    'shuffle',
    'size-actual',
    'size-fullscreen',
    'social-behance',
    'social-dribbble',
    'social-dropbox',
    'social-facebook',
    'social-foursqare',
    'social-github',
    'social-google',
    'social-instagram',
    'social-linkedin',
    'social-pinterest',
    'social-reddit',
    'social-skype',
    'social-soundcloud',
    'social-spotify',
    'social-steam',
    'social-stumbleupon',
    'social-tumblr',
    'social-twitter',
    'social-vkontakte',
    'social-youtube',
    'speech',
    'speedometer',
    'star',
    'support',
    'symbol-female',
    'symbol-male',
    'tag',
    'target',
    'trash',
    'trophy',
    'umbrella',
    'user',
    'user-female',
    'user-follow',
    'user-following',
    'user-unfollow',
    'vector',
    'volume-1',
    'volume-2',
    'volume-off',
    'wallet',
    'wrench'
];
